import classname from 'classname';
import { Modal } from 'components/common';
import Button from 'components/Form/Button';
import { ActionIcon, CaretRightIcon } from 'components/icons';
import FirebaseAnalytics, { AnalyticsLogStatus } from 'libs/analytics';
import { getDeviceType } from 'libs';
import React from 'react';
import { globalStyles } from 'styles';
import styles from './complete-account-modal.module.scss';
export default function CompleteAccountModal({
  showModal,
  handleClose,
  ownerType,
  onClick,
}) {
  return (
    <Modal showModal={showModal} maxWidth={530} handleClose={handleClose}>
      <div className={styles.iconWrapper}>
        <ActionIcon />
      </div>
      <div className={styles.body}>
        <h3>Complete your account verification</h3>
        <p>Before you can withdraw, you'll need to activate your business.</p>
        {ownerType === 'OWNER' && (
          <Button
            variant="primary"
            onClick={() => {
              FirebaseAnalytics.logWithValue('activate_business', {
                STATUS: AnalyticsLogStatus.SUCCESS,
                DEVICE_TYPE: getDeviceType(),
              });
              onClick();
            }}
            className={classname(
              globalStyles.flex,
              globalStyles.alignItemsCenter,
            )}
          >
            <span> Complete your setup</span>
            <CaretRightIcon fill="#232340" />
          </Button>
        )}
      </div>
    </Modal>
  );
}
